import withDebounce from '../../../../../incase-domain/components/utils/WithDebounce';
import NumberInput, {NumberInputProps} from '../../../../../ui/components/NumberInput';

const DebouncedNumberInput = withDebounce<NumberInputProps, number>(NumberInput);

export default DebouncedNumberInput;
